(() => {
  'use strict';
  const node = document.getElementById('FultonsLifestyleConfig');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const rows = [];
  let scheduled = false;
  const imageUrl = (source, width) => {
    const url = new URL(source, location.origin);
    if (url.pathname.includes('/files/')) url.searchParams.set('width', width);
    return url.href;
  };
  function makeCard(item, card) {
    const link = document.createElement('a');
    link.className = 'fo-lifestyle-card' + (item.height > item.width * 1.15 ? ' fo-lifestyle-card--portrait' : '');
    link.href = card.querySelector('a[href]').href;
    link.dataset.featuredProductId = item.id;
    const photo = document.createElement('div');
    photo.className = 'fo-lifestyle-photo';
    const img = document.createElement('img');
    img.src = imageUrl(item.src, 900);
    if (item.src.includes('/files/')) {
      img.srcset = [360, 600, 900, 1200].map(width => `${imageUrl(item.src, width)} ${width}w`).join(', ');
      img.sizes = item.height > item.width * 1.15 ? '(max-width:749px) 45vw, 24vw' : '(max-width:749px) 90vw, 46vw';
    }
    img.width = item.width; img.height = item.height;
    img.alt = item.alt; img.loading = 'lazy'; img.decoding = 'async';
    photo.append(img);
    const copy = document.createElement('div');
    copy.className = 'fo-lifestyle-copy';
    const eyebrow = document.createElement('p'); eyebrow.textContent = config.eyebrow;
    const title = document.createElement('h2');
    const name = card.querySelector('h3')?.textContent || item.title;
    const vendor = (card.dataset.furnitureTags || '') + ' ' + (card.querySelector('.living-test__brand,.fo-brand')?.textContent || '');
    title.textContent = window.FultonsMenuProductName?.(name,vendor) || name;
    const action = document.createElement('span'); action.textContent = config.explore + ' →';
    copy.append(eyebrow, title, action); link.append(photo, copy);
    return link;
  }
  function place() {
    scheduled = false;
    const grid = document.querySelector('.living-test__grid');
    if (!grid) return;
    const cards = [...grid.querySelectorAll(':scope > .living-test__card')].filter(card => !card.hidden && getComputedStyle(card).display !== 'none');
    rows.forEach(row => row.remove()); rows.length = 0;
    if (cards.length < 4) return;
    const matched = config.items.map(item => ({item,card:cards.find(card => card.dataset.productId === item.id)})).filter(pair => pair.card);
    if (!matched.length) return;
    const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
    const roomStory = document.querySelector('.fo-room-story');
    const after = Math.min(cards.length, columns * (roomStory ? 3 : 2));
    const row = document.createElement('section');
    row.className = 'fo-lifestyle-row'; row.setAttribute('aria-label', config.navigation);
    matched.slice(0, 2).forEach(pair => row.append(makeCard(pair.item, pair.card)));
    if (row.children.length === 1) row.classList.add('fo-lifestyle-row--single');
    cards[after - 1].after(row); rows.push(row);
  }
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(place); } };
  document.addEventListener('fultons:catalogue-updated', schedule);
  document.addEventListener('shopify:section:load', schedule);
  matchMedia('(max-width:749px)').addEventListener('change', schedule);
  matchMedia('(max-width:1099px)').addEventListener('change', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
})();
